import {Merchant} from "../../client/state/MerchantStore";
import {BlinkGlobal} from "../UtilsLib";


// TODO @flow this file should be dismantled
class IframeMerchantService {
    init(merchantId) {
        this.merchantId = merchantId;
        BlinkGlobal.iFrameMerchantService = this;
    }

    getMerchant() {
        return Merchant.get(this.merchantId);
    }

    // For hardcoded stuff.
    isMerchant(alias) {
        return this.getMerchant()?.alias === alias;
    }
}

export const iFrameMerchantService = new IframeMerchantService();
